"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargingTransactionTelemetryTrackerSerialization = void 0;
const ChargingTransactionTelemetrySerialization_1 = require("./ChargingTransactionTelemetrySerialization");
class ChargingTransactionTelemetryTrackerSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.charging_transaction_telemetry =
            entity.charging_transaction_telemetry?.map((field) => field
                ? JSON.parse(ChargingTransactionTelemetrySerialization_1.ChargingTransactionTelemetrySerialization.serialize(field))
                : undefined);
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.charging_transaction_telemetry =
            entity.charging_transaction_telemetry?.map((field) => field
                ? ChargingTransactionTelemetrySerialization_1.ChargingTransactionTelemetrySerialization.deserialize(JSON.stringify(field))
                : undefined);
        return copy;
    }
}
exports.ChargingTransactionTelemetryTrackerSerialization = ChargingTransactionTelemetryTrackerSerialization;
